import { Skeleton } from '@dsg-tech/homefield-react';
// This is what the height of the content of the L0 buttons ends up being after accounting for
// font-size and line-height. Not sure if there's a better way to dynamically define this. Edit this
// value if you need to adjust the height of a nav item for CLS!
//
// Last Updated: 8/17/2025
const CATEGORY_CONTENT_TEXT_HEIGHT = '20px';

const PrimaryCategoriesItem = () => (
  <span
    data-testid="PrimaryCategoriesPendingItem"
    className="desktop-nav-container__nav--list-item hmf-p-xxs">
    <Skeleton height={CATEGORY_CONTENT_TEXT_HEIGHT} width={75} />
  </span>
);

const PrimaryCategoriesPending = () => {
  return (
    <>
      <PrimaryCategoriesItem />
      <PrimaryCategoriesItem />
      <PrimaryCategoriesItem />
      <PrimaryCategoriesItem />
      <PrimaryCategoriesItem />
      <PrimaryCategoriesItem />
      <PrimaryCategoriesItem />
      <PrimaryCategoriesItem />
    </>
  );
};

export default PrimaryCategoriesPending;
